module.exports = __webpack_public_path__ + "static/img/noData.ee6cfa65.png";